import { useQuery } from 'react-query';

import { getValidationTypeDrillDown as queryFn } from 'api/endPoints/getValidationTypeDrillDown';

export const useQueryGetValidationTypeDrillDown = (params) => {
    return useQuery<IValidationTypeDrillDownResponse, QueryError>(
        ['getValidationTypeDrillDown', params],
        () => queryFn(params),
        {
            enabled: Boolean(params.componentId),
        },
    );
};

export interface IValidationTypeDrillDownResponse {
    headers: {
        accessor: string;
        clickable: boolean;
        colorable: boolean;
        header: string;
        order: number;
        sortable: string;
    }[];
    rows: { [key: string]: unknown }[];
    title: string;
    validationDescription: string;
}
